"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInfectiousDiseaseTestUpdateDto = instanceOfInfectiousDiseaseTestUpdateDto;
exports.InfectiousDiseaseTestUpdateDtoFromJSON = InfectiousDiseaseTestUpdateDtoFromJSON;
exports.InfectiousDiseaseTestUpdateDtoFromJSONTyped = InfectiousDiseaseTestUpdateDtoFromJSONTyped;
exports.InfectiousDiseaseTestUpdateDtoToJSON = InfectiousDiseaseTestUpdateDtoToJSON;
exports.InfectiousDiseaseTestUpdateDtoToJSONTyped = InfectiousDiseaseTestUpdateDtoToJSONTyped;
const InfectiousDiseaseTestType_1 = require("./InfectiousDiseaseTestType");
/**
 * Check if a given object implements the InfectiousDiseaseTestUpdateDto interface.
 */
function instanceOfInfectiousDiseaseTestUpdateDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('testDate' in value) || value['testDate'] === undefined)
        return false;
    return true;
}
function InfectiousDiseaseTestUpdateDtoFromJSON(json) {
    return InfectiousDiseaseTestUpdateDtoFromJSONTyped(json, false);
}
function InfectiousDiseaseTestUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeFromJSON)(json['code']),
        'testDate': (new Date(json['testDate'])),
    };
}
function InfectiousDiseaseTestUpdateDtoToJSON(json) {
    return InfectiousDiseaseTestUpdateDtoToJSONTyped(json, false);
}
function InfectiousDiseaseTestUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': (0, InfectiousDiseaseTestType_1.InfectiousDiseaseTestTypeToJSON)(value['code']),
        'testDate': ((value['testDate']).toISOString()),
    };
}
//# sourceMappingURL=InfectiousDiseaseTestUpdateDto.js.map